import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import { route } from "./../../../router/route";
import RedBtn from "./../../../component/atoms/button/redBtn";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import Pagination from "./../../../component/molecules/pagination";
import Modal from "../../../component/templates/Modal";
import SmsApi from "../../../api/sms.api";
import moment from "moment";
import Empty from "../../../component/molecules/empty";
import PretendardText from "../../../component/atoms/text/pretendardText";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const OperationMessageSmsDetail = () => {
  const { type } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getSMSList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [smsList, setSmsList] = useState([]);

  const getSMSList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (type === "send") {
        data.sendComplete = "Active";
      } else {
        data.isNow = "Inactive";
      }

      const response = (await SmsApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
        };
      });

      setSmsList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 체크 관련 ---------- //
  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (smsList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = smsList.every((item) => idsInArray1.has(item.id));

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, smsList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      let delIds = checkedListStorage.map((item) => item.id);

      const data = {
        ids: delIds,
        allFlag: false,
      };

      await SmsApi.deleteSms(data);

      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);
      await getSMSList();

      navigate(`${route.operation_message_sms_detail}/${type}?page=1`);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>
            {type === "send" ? "최근 30일 발송 SMS" : "발송 예약 SMS"}
          </TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount fullText={"SMS"} count={pagination.totalCount} />
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                {type === "send" ? " 내역 삭제" : "예약취소 및 삭제"}
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="53px" />
              {/* 발송일 */}
              <col width="228px" />
              {/* 보낸사람 */}
              <col width="124px" />
              {/* 받는사람 */}
              <col width="164px" />
              {/* 제목/내용 */}
              <col width="419px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...smsList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          smsList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    발송일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보낸사람
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    받는사람
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    제목/내용
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {smsList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: 128,
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.sendDate).format("YYYY-MM-DD HH:mm")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 100,
                        }}
                      >
                        {item.adminName}
                      </TableText>
                    </Td>
                    <Td>
                      <PretendardText
                        style={{
                          maxWidth: 100,
                          color: "#aaa",
                          fontSize: "14px",
                          fontWeight: 500,
                          lineHeight: "22px",
                        }}
                      >
                        {item.groupId === 0
                          ? item.phoneNumberList?.length > 0
                            ? item.phoneNumberList.map((item) => `${item}\n`)
                            : "전체회원"
                          : item.group?.title}
                      </PretendardText>
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: 367,
                            fontWeight: "400",
                            fontSize: 14,
                            lineHeight: "20.25px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            wordBreak: "normal",
                            whiteSpace: "normal",
                            WebkitLineClamp: 2, // 2줄부터 ... 표시
                          }}
                        >
                          {item.content}
                        </TableText>
                        <a href={item.url} target="_blank" rel="noreferrer">
                          <TableText
                            style={{
                              maxWidth: 367,
                              fontWeight: "400",
                              fontSize: 14,
                              lineHeight: "20.25px",
                              overflow: "visible",
                              whiteSpace: "normal",
                              textOverflow: "clip",
                              wordBreak: "normal",
                              cursor: "pointer",
                            }}
                          >
                            ({item.url})
                          </TableText>
                        </a>
                      </div>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {smsList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={`${route.operation_message_sms_detail}/${type}`}
            queryString={``}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}
    </>
  );
};

export default OperationMessageSmsDetail;
